import { Box, CircularProgress } from "@mui/material";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { markdownHeadingComponents } from "@/lib/markdownHeadings";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { isOrtexApp } from "@/lib/utils";
import styles from "./AINote.module.scss";

interface Props {
    content: string | null;
    isLoading?: boolean;
}

const AINote = ({ content, isLoading }: Props) => {
    if (isLoading) {
        return (
            // Keyed apart from the note: otherwise React reuses the spinner's box for the note and the
            // browser reports the box growing in place as a layout shift.
            <Box key="loading" className={styles.loading}>
                <CircularProgress size={36} />
            </Box>
        );
    }

    if (!content) {
        return null;
    }

    return (
        <Box key="note" className={styles.AINote}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                    ...markdownHeadingComponents,
                    a: ({ node, ...props }) => <a target={isOrtexApp() ? "_self" : "_blank"} rel="noopener noreferrer" {...props} />,
                    img: () => null,
                }}
            >
                {content}
            </ReactMarkdown>
        </Box>
    );
};

export default AINote;
